var redefine = require('../internals/redefine');

module.exports = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};



//////////////////
// WEBPACK FOOTER
// /Volumes/Box/sites/wandsworthhub/app/bedrock/web/app/themes/wandsworthhub/node_modules/core-js/internals/redefine-all.js
// module id = 46
// module chunks = 0